import api from "./api";
export const criminalProcedure = (id) => api.get(`/ujms/cases/${id}/criminal-procedure`);
export const recordDiscoveryReceipt = (id, data) => api.post(`/ujms/cases/${id}/criminal-procedure/discovery`, data);
export const hearingFlow = (id) => api.get(`/ujms/hearings/${id}/flow`);
export const recordHearingDecision = (id, data) => api.post(`/ujms/hearings/${id}/decision`, data);
export const routingReview = (id) => api.get(`/ujms/cases/${id}/routing-review`);
export const integrityQueue = () => api.get("/ujms/case-integrity");
export const transferCase = (id, data) => api.post(`/ujms/cases/${id}/division-review`, data);
export const ispConnections = () => api.get("/ujms/isp-workflows/connections");
export const caseIspRequests = (id) => api.get(`/ujms/cases/${id}/isp-workflows`);
export const submitIspRequest = (id, data) => api.post(`/ujms/cases/${id}/isp-workflows`, data);
export const ispWorkflows = () => api.get("/ujms/chri/workflows");
export const ispWorkflow = (id) => api.get(`/ujms/chri/workflows/${id}`);
export const reviewIspWorkflow = (id, data) => api.post(`/ujms/chri/workflows/${id}/review`, data);